




































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../../components/general/OnscreenMenu.vue";
import GroupsBookingDetails from "./GroupsBookingDetails.vue";

import UserJson from "../../shared/UserJson";
import GroupBookingJson from "../../shared/GroupBookingJson";
import CustomerJson from "../../shared/CustomerJson";

import { GroupBookingStatus } from "../../shared/GroupBookingStatus";
import { Gender } from "../../shared/Gender";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "GroupsOffers",
  components: {
    Loading,
    TableView,
    OnscreenMenu,
    GroupsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    GroupsBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      GroupBookingStatus: GroupBookingStatus,
      useFilters: false as boolean,
      filterState: null as GroupBookingStatus | null,
      filterStaffId: null as number | null,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      allUsers: null as UserJson[] | null,
      requestedGroupBookings: null as GroupBookingJson[] | null,
      requestedGroupBookingsMoreAvailable: null as boolean | null,
      searchString: null as string | null,
      selectedGroupBookingId: null as number | null,
      selectedGroupBooking: null as GroupBookingJson | null,
      detailsMode: "read",
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  mounted() {},
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadGroupRequests();
      this.loadAllUsers();
    },

    async reloadSelectedGroupBooking() {
      this.selectedGroupBooking = null;
      this.toggleDetails();
      if (this.selectedGroupBookingId != null) {
        try {
          this.selectedGroupBooking = await this.restClient.getGroupBooking(this.selectedGroupBookingId);
          this.openDetails(this.selectedGroupBooking, "read");
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadGroupRequests(loadMore: null = null) {
      var states: GroupBookingStatus[] = [
        GroupBookingStatus.requested,
        GroupBookingStatus.offerToCustomer,
        GroupBookingStatus.offerAccepted,
      ];
      let staffId = null;

      //filters
      if (this.useFilters) {
        if (this.filterState != null) {
          states = [this.filterState];
        }
        if (this.filterStaffId != null) {
          staffId = this.filterStaffId;
        }
      }

      var afterDateTime = null;
      var beforeDateTime = null;
      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.requestedGroupBookings != null) {
        this.requestedGroupBookingsMoreAvailable = null;

        skipAmount = this.requestedGroupBookings.length;
      } else {
        this.requestedGroupBookings = null;
      }

      //final load
      if (this.restClient != null) {
        try {
          let bookings = await this.restClient.getGroupBookings(
            states,
            staffId,
            afterDateTime,
            beforeDateTime,
            this.searchString,
            null,
            skipAmount
          );

          if (loadMore && this.requestedGroupBookings != null) {
            this.requestedGroupBookings = this.requestedGroupBookings.concat(bookings.groupBookings);
          } else {
            this.requestedGroupBookings = bookings.groupBookings;
          }

          this.requestedGroupBookingsMoreAvailable = bookings.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadAllUsers() {
      try {
        this.allUsers = await this.restClient.getUsers();
      } catch (e) {
        alert(e.message);
      }
    },

    resetSearchString() {
      this.searchString = "";
      this.loadGroupRequests();
    },

    openDetails(item: GroupBookingJson | null, mode: string) {
      if (item != null) {
        //this.selectedBirthday = JSON.parse(JSON.stringify(item))
        this.selectedGroupBookingId = item.ID;
      } else {
        this.selectedGroupBookingId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadGroupRequests();
    },

    removeUseFilters() {
      this.useFilters = false;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadGroupRequests();
    },

    getStaffFullName(staffId: number | null) {
      if (staffId != null) {
        if (this.allUsers != null) {
          let staff = this.allUsers.find((user) => user.ID == staffId);

          return staff?.firstName + " " + staff?.lastName;
        }
      } else {
        return "--";
      }
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    groupColumns: function (): TableViewColumnDefinitions<GroupBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name",
          td: (i) =>
            i.customer.guardianLastName != ""
              ? i.customer.guardianLastName + ", " + i.customer.guardianFirstName
              : "--",
        },
        {
          th: "Gruppe",
          td: (i) => (i.customer.guardianOrganisation != "" ? i.customer.guardianOrganisation : "--"),
        },
        {
          th: "Datum",
          td: (i) => DateFormatter.formatDateWeekday(new Date(i.beginDateTime)),
          sortBy: (i) => i.beginDateTime,
        },
        {
          th: "Uhrzeit",
          td: (i) =>
            DateFormatter.formatTime(new Date(i.beginDateTime)) +
            " – " +
            DateFormatter.formatTime(new Date(i.endDateTime)),
        },
        {
          th: "Zuständigkeit",
          td: (i) => vue.getStaffFullName(i.staffId),
        },
        {
          th: "Status",
          td: (i) => vue.GroupsBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<GroupBookingJson>[];
    },
  },
});
